"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeRequestLengths = void 0;
exports.ChangeRequestLengths = {
    TEXTAREA_ROWS: 10,
    TEXTAREA_MAX_LENGTH: 4096,
    INPUT_MAX_LENGTH: 256,
};
